// Angular
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { AuthService, currentUser, isLoggedIn, Login, Logout, UserLoaded } from '../../../../../core/auth';
import { environment } from '@app/../environments/environment';
import { User } from '@app/model/user';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ModalCreateSignInUpComponent } from '@app/views/pages/sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component';
import { Router } from '@angular/router';
import { AuthenticateService } from '@app/api/authenticate.service';

@Component({
  selector: 'kt-user-profile4',
  templateUrl: './user-profile4.component.html',
  styleUrls: ['./user-profile4.component.scss'],
})
export class UserProfile4Component implements OnInit {
  title = 'Welcome word';
  content = 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus.';
  // Public properties
  user$: Observable<User>;
  currentUser: any;
  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;
  backend = environment.backendhost;
  isShow: boolean = false;
  currentPermissions: any;
  showUserPopup: boolean = false;
  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   */
  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private authenticateService: AuthenticateService
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  private permissionsLoaded = false;

  private retryCount = 0;
  private isLoadingUser = false;

  ngOnInit(): void {
    // 1. isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
      if (loggedIn) {
        this.isShow = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.isShow = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    // 2. currentUser — có giá trị sau khi API getMyInfo trả về
    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      if (res) {
        this.isShow = true;
        this.currentUser = res;
        this.isLoadingUser = false;
        if (!this.permissionsLoaded) {
          this.permissionsLoaded = true;
          this.getMyPermissions();
        }
      }
      this.cdr.detectChanges();
    });

    // 3. Fallback: nếu NGRX effect không load được user sau 3s → gọi API trực tiếp
    setTimeout(() => {
      if (this.isShow && !this.currentUser) {
        this.loadUserDirectly();
      }
    }, 3000);
  }

  /**
   * Gọi API getMyInfo trực tiếp từ component (bypass NGRX effect)
   * Dùng khi NGRX loadUser$ effect fail
   */
  loadUserDirectly() {
    if (this.isLoadingUser || this.currentUser) return;
    if (this.retryCount >= 3) {
      console.warn('[AUTH] Max retries reached, giving up loading user');
      return;
    }
    this.retryCount++;
    this.isLoadingUser = true;
    console.log('[AUTH] Direct API call attempt', this.retryCount);

    this.authenticateService.apiAuthenticateGetMyInfoGet().subscribe(
      (res) => {
        this.isLoadingUser = false;
        console.log('[AUTH] Direct API response:', JSON.stringify(res).substring(0, 200));
        if (res && res.success && res.user) {
          this.currentUser = res.user;
          this.isShow = true;
          // Cập nhật NGRX store để các component khác cũng có data
          this.store.dispatch(new UserLoaded({ user: res.user }));
          if (!this.permissionsLoaded) {
            this.permissionsLoaded = true;
            this.getMyPermissions();
          }
          this.cdr.detectChanges();
        } else if (res && res.success) {
          // Có thể response khác format: res.data thay vì res.user
          const user = res.user || res.data;
          if (user) {
            this.currentUser = user;
            this.isShow = true;
            this.store.dispatch(new UserLoaded({ user: user }));
            this.cdr.detectChanges();
          } else {
            console.warn('[AUTH] API success but no user data in response:', Object.keys(res));
            // Retry sau 2s
            setTimeout(() => this.loadUserDirectly(), 2000);
          }
        } else {
          console.warn('[AUTH] API returned success=false');
          // Retry sau 2s
          setTimeout(() => this.loadUserDirectly(), 2000);
        }
      },
      (error) => {
        this.isLoadingUser = false;
        console.error('[AUTH] Direct API error:', error.status, error.message);
        // Retry sau 2s (trừ 401/403)
        if (error.status !== 401 && error.status !== 403) {
          setTimeout(() => this.loadUserDirectly(), 2000);
        }
      }
    );
  }

  /**
   * Log out
   */
  logout() {
    this.store.dispatch(new Logout());
  }
  //signIn/Up
  openModalSignInUp(type) {
    const dialogRef = this.dialog.open(ModalCreateSignInUpComponent, {
      width: '900px',
      data: { type: type, returnUrl: location.pathname },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        if (result.event) {
          if (result.type == 'signin') {
            //this.toastr.success('Đăng nhập thành công');
          } else if (result.type == 'signup') {
            //this.toastr.success('Đăng kí thành công');
          } else {
            this.toastr.success('Thực hiện thao tác thành công');
          }
        }
      }
    });
  }
  getMyPermissions() {
    this.authService.getMyPermissions().subscribe((res) => {
      this.currentPermissions = res;
      this.cdr.markForCheck();
    });
  }
  getAvatarSrc(user: User | null | undefined): string {
    if (user && user.avatar) {
      return this.backend + user.avatar;
    }
    return 'assets/media/users/default.jpg';
  }

  // Check if user has admin role
  isAdminUser(user: User | null | undefined): boolean {
    if (!user || !user.roles || !Array.isArray(user.roles)) {
      return false;
    }
    const adminRoles = ['Admin', 'Content Admin', 'Salesman'];
    const hasAdminRole = user.roles.some((role: string) => adminRoles.includes(role));
    return hasAdminRole;
  }

  // User popup methods
  toggleUserPopup() {
    if (window.innerWidth <= 1024) {
      this.showUserPopup = !this.showUserPopup;
      // Nếu mở popup mà currentUser chưa có → gọi API trực tiếp
      if (this.showUserPopup && !this.currentUser) {
        this.loadUserDirectly();
      }
      this.cdr.detectChanges();
    }
  }

  hideUserPopup() {
    this.showUserPopup = false;
    this.cdr.detectChanges();
  }
  //end signIn/Up
}
